import { render } from "./ContractCommentBlockComponent.vue?vue&type=template&id=636d28e0&scoped=true"
import script from "./ContractCommentBlockComponent.vue?vue&type=script&lang=js"
export * from "./ContractCommentBlockComponent.vue?vue&type=script&lang=js"

import "./ContractCommentBlockComponent.vue?vue&type=style&index=0&id=636d28e0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636d28e0"]])

export default __exports__